import { Component, OnInit } from '@angular/core';

import { Errors, LocalService, ManagerService } from '../../core';

@Component({
  selector: 'app-admin-manage-claims',
  templateUrl: './admin-manage-claims.component.html',
  styleUrls: ['./admin-manage-claims.component.scss'],
})
export class AdminManageClaimsComponent implements OnInit {
  errors: Errors = { errors: {} };
  userProfile: any;
  defaultTab: number | undefined;
  tabs: any[] = [];

  constructor(private managerService: ManagerService) {}

  ngOnInit() {
    this.userProfile = LocalService.get('userProfile');
    this.initializeTabs();
    this.getCompanyPreferences();
  }

  initializeTabs() {
    this.tabs = [
      {
        id: 0,
        label: 'adminClaim.heading',
        icon: 'assets/images/icons/star.svg',
        isActive: true,
        isVisible: true,
        iconHtml: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none"
        stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"
        class="lucide lucide-dollar-sign h-4 w-4">
        <line x1="12" x2="12" y1="2" y2="22"></line>
        <path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"></path>
      </svg>`
      },
      {
        id: 1,
        label: 'Claimed Earnings',
        icon: 'assets/images/icons/activities.svg',
        isActive: false,
        isVisible: true,
        iconHtml: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" class="lucide lucide-award h-4 w-4"><path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"></path><circle cx="12" cy="8" r="6"></circle></svg>`
      }
    ];
  }

  setTab(index: number) {
    if (this.defaultTab === index) {
      return;
    }
    this.defaultTab = index;
  }

  getCompanyPreferences() {
    if (this.userProfile && this.userProfile.company && this.userProfile.company.id) {
      const companyParams = { companyId: this.userProfile.company.id };
      this.managerService.getCompanyPreferences(companyParams).subscribe(
        (data) => {
          const isSalesChallenge = data.companyPreferences.length > 0
            ? data.companyPreferences[0].enabled
            : false;
          this.setTab(isSalesChallenge === true ? 0 : 1);
        },
        (err) => {
          this.errors = err;
          this.setTab(0);
        }
      );
    } else {
      this.setTab(0);
    }
  }
}
